
<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'app',
  data() {
    return {
      showPage:1,
    }
  },
  created () {
    if (this._isMobile()) {
      this.showPage = 1

    } else {
      this.showPage = 2

    }
    
  },
  methods: {
  // 判断是否移动端
    _isMobile () {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
  },

}
</script>

<style>
  @import "./assets/css/main.css";
/* 解决element 弹窗页面抖动问题 */
  body{
    padding-right: 0 !important;
  }
  body::-webkit-scrollbar{
  width:0;
}
</style>
